import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminTermsCondition from "../../../views/admin/cms/AdminTermsCondition";

const AdminTermsConditionPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminTermsCondition />
      <AdminFooter />
    </div>
  );
};

export default AdminTermsConditionPage;
